import {Injectable} from "@angular/core";
import {Storage} from "@ionic/storage";

@Injectable()
export class LocalStorageWrapper {
    constructor(private storage: Storage) {
        if(!this.isInitialized) {
            this.init();
        }
    }

    isInitialized: boolean = false;

    public ready() {
        return this.storage.ready();
    }

    public init() {
        let processData = () => {
            this.storage.length().then(keysNumber => {
                if(keysNumber == 0 && window.localStorage.length > 0) {
                    for (var i = 0; i <= localStorage.length - 1; i++) {
                        var key = localStorage.key(i);
                        this.storage.set(key, window.localStorage.getItem(key)).then();
                    }

                }

                if(keysNumber > 0) {
                    let restartRequired: boolean = !(window.localStorage.getItem('api_token'));

                    this.storage.forEach((value, key) => {
                        window.localStorage[key] = value;
                    }).then(() => {
                        if(restartRequired && window.localStorage['api_token']) {
                            window.location.reload();
                        }
                    });


                }

            }).catch(console.log);
        }

        this.isInitialized = true;
        this.storage.ready().then(processData);
    }

    public setItem(key, data) {
        window.localStorage.setItem(key, data);
        this.storage.set(key, data).then();
    }

    public getItem(key) {
        return window.localStorage.getItem(key);
    }

    public removeItem(key) {
        window.localStorage.removeItem(key);
        this.storage.remove(key).then();
    }
    public removeAll() {
        return this.storage.clear();
    }
}



// WEBPACK FOOTER //
// ./src/providers/local-storage-wrapper/local-storage-wrapper.ts